/** returns Policies List
@return { Array }
*/
export const getPoliciesList = state => {
	return state.policiesList
}

/** returns Policy Receipts List
@return { Array }
*/
export const getPolicyReceiptsList = state => {
	return state.policyReceiptsList
}